import React, { useState, useRef, useEffect } from 'react';

const DropdownMenu = ({ options = [], onSelect, w1,w2 }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(options[0] || '');
    const dropdownRef = useRef();
  
    const toggleDropdown = () => setIsOpen(prev => !prev);
  
    const handleOptionClick = (option) => {
      setSelected(option);
      setIsOpen(false);
      onSelect?.(option);
    };
  
    useEffect(() => {
      // Notify parent of initial selection
      if (options.length > 0 && onSelect) {
        onSelect(options[0]);
      }
  
      const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [options, onSelect]);

  return (
    <div className="relative w-max mx-auto" ref={dropdownRef}>
      <button
        type="button"
        onClick={toggleDropdown}
        className={`w-[${w1}px] h-[38px] px-2 py-2.5 rounded-sm text-slat-800 text-sm font-medium cursor-pointer flex items-center flex justify-between`}
      >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 fill-[#666] rotate-180"
            viewBox="0 0 23 23"
        >
            <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2" />
        </svg>
      </button>

      {isOpen && (
        <ul className="absolute top-0 shadow-lg bg-white py-2 z-[1000] min-w-full w-max rounded-sm max-h-96 overflow-auto mt-1">
          {options.map((option, index) => (
            <li
              key={index}
              onClick={() => handleOptionClick(option)}
              className={`w-[${w2}px] h-[35px] px-2 py-1.5 hover:bg-gray-50 text-slate-900 text-[13px] text-left font-medium cursor-pointer`}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownMenu;
